module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"memorize":"Memorer","quiz":"Quiz","seconds":"sek"},"en":{"memorize":"Memorize","quiz":"Quiz","seconds":"sec"}}')
  delete Component.options._Ctor
}
